import(/* webpackMode: "eager" */ "/github/workspace/nextjs-frontend/src/app/web-chat/page.tsx");
